const quoteForm = document.getElementById('quote-form');

quoteForm.addEventListener('submit', (event) => {
  event.preventDefault();

  const name = document.getElementById('quote-form--name').value;
  const email = document.getElementById('quote-form--email').value;
  const location = document.getElementById('quote-form--location').value;
  const building = document.getElementById('quote-form--building').value;
  const suite = document.getElementById('quote-form--suite').value;
  const submitButton = document.getElementById('quote-form--submit');

  const fields = {
    name,
    email,
    location,
    suite: `${building} - ${suite}`,
    items: window.cartItems ? window.cartItems.map((item) => ({ sku: item.sku, quantity: item.quantity })) : [],
  };

  // add loading spinner
  submitButton.setAttribute('aria-disabled', true);
  submitButton.classList.add('loading');
  quoteForm.querySelector('.loading-overlay__spinner').classList.remove('hidden');

  fetch('https://hem-ts-studio.hemdesignstudio.workers.dev', {
    method: 'POST',
    body: JSON.stringify({
      fields,
    }),
  })
    .then((response) => {
      return response.json();
    })
    .then((data) => {
      console.log('Success:', data);

      // empty cart
      fetch(`${window.Shopify.routes.root}cart/update.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          updates: window.cartItems.map(() => 0),
        }),
      })
        .then(() => {
          submitButton.setAttribute('aria-disabled', false);
          submitButton.classList.remove('loading');
          quoteForm.querySelector('.loading-overlay__spinner').classList.add('hidden');

          // navigate to /pages/thank-you
          window.location.href = '/pages/thank-you';
        })
        .catch((error) => {
          submitButton.setAttribute('aria-disabled', false);
          submitButton.classList.remove('loading');
          quoteForm.querySelector('.loading-overlay__spinner').classList.add('hidden');

          console.log('Cart update error:', error);
        });
    })
    .catch((error) => {
      console.log('Error:', error);
      submitButton.setAttribute('aria-disabled', false);
      submitButton.classList.remove('loading');
      quoteForm.querySelector('.loading-overlay__spinner').classList.add('hidden');
    });
});
